import React from 'react';
import {
  Button,
  IconAiStar,
  IconAiRocket,
  IconChat,
  IconHeart,
  IconSend,
} from 'gatorcomponents';
import useLocale from '@/hooks/useLocale';
import * as Styles from './TrendingPost.styles';

const TrendingPost = ({ highlightedPost, onBoostClick, isLoading }) => {
  const { marketing: marketingLocale } = useLocale();
  const multiAgentScreensLocale = marketingLocale && marketingLocale.multiAgentScreens;
  const adsInsightsLocale = (multiAgentScreensLocale && multiAgentScreensLocale.adsInsights) || {};

  const formatNumber = (num) => {
    if (!num && num !== 0) return 0;
    if (num >= 1000000) {
      return `${(num / 1000000).toFixed(1)}M`;
    }
    if (num >= 1000) {
      return `${(num / 1000).toFixed(1)}k`;
    }
    return num;
  };

  const postImage = highlightedPost && highlightedPost.image;
  const likes = formatNumber(highlightedPost && highlightedPost.likes);
  const comments = formatNumber(highlightedPost && highlightedPost.comments);
  const shares = formatNumber(highlightedPost && highlightedPost.shares);

  return (
    <Styles.Container>
      <Styles.PostImageWrapper>
        <Styles.PostImage
          src={postImage}
          alt={adsInsightsLocale.trendingPostTitle}
        />
        <Styles.PostMetrics>
          <Styles.MetricItem>
            <Styles.MetricIcon>
              <IconHeart size="sm" color="lowDark" />
            </Styles.MetricIcon>
            {likes}
          </Styles.MetricItem>
          <Styles.MetricItem>
            <Styles.MetricIcon>
              <IconChat size="sm" color="lowDark" />
            </Styles.MetricIcon>
            {comments}
          </Styles.MetricItem>
          <Styles.MetricItem>
            <Styles.MetricIcon>
              <IconSend size="sm" color="lowDark" />
            </Styles.MetricIcon>
            {shares}
          </Styles.MetricItem>
        </Styles.PostMetrics>
      </Styles.PostImageWrapper>

      <Styles.Content>
        <Styles.Header>
          <Styles.IconWrapper>
            <IconAiStar gradient="secondary" size="md" />
          </Styles.IconWrapper>
          <Styles.Title>
            {adsInsightsLocale.trendingPostTitle}
          </Styles.Title>
          <Styles.Description>
            {adsInsightsLocale.trendingPostDescription}
          </Styles.Description>
        </Styles.Header>

        <Styles.ButtonWrapper>
          <Button
            iconLeft={!isLoading ? <IconAiRocket color="highPure" /> : undefined}
            label={adsInsightsLocale.trendingPostButton}
            size="large"
            notFillSVG
            onClick={onBoostClick}
            disabled={isLoading}
            loading={isLoading}
          />
        </Styles.ButtonWrapper>
      </Styles.Content>
    </Styles.Container>
  );
};

export default TrendingPost;
